import UserBookByStatusCardContent from "./UserBookByStatusCardContent";
import { LetterbooksSerializersBook, UserBookSerializersUserBook } from "types/serializers";

export default function UserBookByStatusWatcher({
  className = "",
  book,
  userBook,
}: {
  book: LetterbooksSerializersBook;
  userBook: UserBookSerializersUserBook;
  className?: string;
}) {

  return (
    <UserBookByStatusCardContent
      userBook={userBook}
      book={book}
      className={className}
      edition={userBook.edition}
    />
  );
}
